import { c as _c } from "react/compiler-runtime";
import { Breadcrumbs as SparkyBreadcrumbs, BreadcrumbsItem as SparkyBreadcrumbsItem } from '@petsmart-ui/sparky';
import { JsonLd } from '@libs/common-next';
import BreadcrumbsAdjuster from './BreadcrumbsAdjuster';
import type { BreadcrumbsItem, BreadcrumbsProps } from './types';
import './Breadcrumbs.scss';
export default function Breadcrumbs(t0) {
  const $ = _c(25);
  let containerSelector;
  let items;
  let props;
  let seo;
  let t1;
  if ($[0] !== t0) {
    ({
      containerSelector,
      items,
      seo,
      isLastItemVisible: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = containerSelector;
    $[2] = items;
    $[3] = props;
    $[4] = seo;
    $[5] = t1;
  } else {
    containerSelector = $[1];
    items = $[2];
    props = $[3];
    seo = $[4];
    t1 = $[5];
  }
  const isLastItemVisible = t1 === undefined ? true : t1;
  let t2;
  if ($[6] !== items) {
    t2 = items.map(_temp);
    $[6] = items;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== isLastItemVisible) {
    t3 = !isLastItemVisible && <SparkyBreadcrumbsItem className="breadcrumbs__item--hidden" />;
    $[8] = isLastItemVisible;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t2 || $[11] !== t3) {
    t4 = <>{t2}{t3}</>;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== props || $[14] !== t4) {
    t5 = <SparkyBreadcrumbs {...props}>{t4}</SparkyBreadcrumbs>;
    $[13] = props;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== containerSelector || $[17] !== isLastItemVisible) {
    t6 = containerSelector && <BreadcrumbsAdjuster containerSelector={containerSelector} isLastItemVisible={isLastItemVisible} />;
    $[16] = containerSelector;
    $[17] = isLastItemVisible;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== seo) {
    t7 = seo && <JsonLd {...seo} />;
    $[19] = seo;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== t5 || $[22] !== t6 || $[23] !== t7) {
    t8 = <>{t5}{t6}{t7}</>;
    $[21] = t5;
    $[22] = t6;
    $[23] = t7;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  return t8;
}
function _temp(item) {
  return <SparkyBreadcrumbsItem {...item} key={item.key} />;
}